// @flow
import { fetchAvaWebAppSession } from './index';
import { startConversationReadClient } from '../conversation';
import { getSocketIfExist, createV1Socket } from '../../utils/getSocket';

export const reconnectToWebSocket = () => async (dispatch: Function, getState: Function): Promise<void> => {
  // eslint-disable-next-line no-console
  const ws = getSocketIfExist();
  if (ws) ws.close();
  const { scribeConversation, scribeSession } = getState();
  const { currentPlatform } = scribeSession;
  dispatch({ type: 'RETRY_RECONNECT_WEBSOCKET' });

  const { reconnectionWsUrl, scribe, status } = scribeConversation;
  const { captioner } = scribeSession;

  if (reconnectionWsUrl) {
    dispatch({ type: 'CONSUME_RECONNECTION_WS_URL' });
    await createV1Socket(
      reconnectionWsUrl,
      { ...captioner, parse: captioner },
      {
        roomId: status.id,
        scribe,
      }
    );
  } else {
    const { status } = scribeConversation;
    await fetchAvaWebAppSession({ roomId: status?.id })(dispatch, getState);
  }
  startConversationReadClient()(dispatch, getState);
};

export const setShouldShowReconnectingBanner = (shouldShow: boolean) => ({
  type: 'SET_SHOULD_SHOW_RECONNECTING_BANNER',
  payload: shouldShow,
});

export const setWebsocketStatus = (status: 'online' | 'offline' | 'reconnecting') => ({
  type: 'SET_WEBSOCKET_STATUS',
  payload: status,
});
